import React from 'react'
import styles from './styles.module.css'

let VRSupported = ({ renderer, display }) => (
    <div className={styles.webvrSupported} 
         onClick={(e) => {
             renderer.vr.setDevice(display)
             display.requestPresent( [ { source: renderer.domElement } ] )
             e.preventDefault()
         }}
         title="Activate WebVR" />
)

let VRNotSupported = () => (
    <div className={styles.webvrNotSupported} title="WebVR not supported" />
)

class WebVR extends React.Component {

    constructor() {
        super();

        this.state = {
            vrSupported: null,
            display: null
        }
    }

    componentDidMount() {
        if ("getVRDisplays" in navigator) {

            window.addEventListener('vrdisplayconnect', (e) => {
                this.setState({ vrSupported: true, display: e.display })
                this.props.renderer.vr.setDevice(e.display)
                e.display.requestPresent( [ { source: this.props.renderer.domElement } ] )
            }, false )

            window.addEventListener('vrdisplaydisconnect', (e) => {
                this.setState({ vrSupported: false })
            }, false )

            window.addEventListener('vrdisplayactivate', (e) => {
                this.setState({ vrSupported: true, display: e.display })
                this.props.renderer.vr.setDevice(e.display)
                e.display.requestPresent( [ { source: this.props.renderer.domElement } ] )
            }, false )

            navigator.getVRDisplays().then((displays) => {
                if ( displays.length > 0 ) {
                    this.setState({ vrSupported: true, display: displays[0] })
				} else {
                    this.setState({ vrSupported: false })
				}
            })
            
        } else {
            this.setState({ vrSupported: false })
        }
    }

    render() {
        let Supported = this.props.VRSupportedComponent || VRSupported
        let NotSupported = this.props.VRNotSupportedComponent || VRNotSupported

        if (this.state.vrSupported === null) return <div /> 
        
        if (this.state.vrSupported) 
            return <Supported renderer={this.props.renderer} display={this.state.display} />
        
        return <NotSupported />
    }
}

export default WebVR


// WEBPACK FOOTER //
// /opt/build/repo/src/components/WebVR/index.js